// Backend API URL — dynamically resolve based on host environment
const getBaseUrl = () => {
  if (
    typeof window !== "undefined" &&
    window.location.hostname &&
    window.location.hostname !== "localhost" &&
    window.location.hostname !== "127.0.0.1"
  ) {
    if (!process.env.REACT_APP_API_URL || process.env.REACT_APP_API_URL.includes("localhost")) {
      return "https://api.miaomorfia.co.uk/";
    }
  }

  const rawUrl = process.env.REACT_APP_API_URL || "http://localhost:8000";
  return rawUrl.endsWith("/") ? rawUrl : `${rawUrl}/`;
};

const baseUrl = getBaseUrl();

export default baseUrl;